import { Component } from "@angular/core";

@Component({
  templateUrl: './supplier-search.component.html'
})
export class SupplierSearchComponent{

}